// External Dependencies
import GroupIcon from '@mui/icons-material/Group';
import styled from 'styled-components';

// Internal Dependencies
import {
  DetailCard,
} from 'components/shared';

// Local Dependencies
import OrganizationDirectorsTable from './OrganizationDirectorsTable';

// Local Typings
interface Props {
  directors: GQL.IOrganization['directors'];
}

// Local Variables
const StyledSection = styled.section(({ theme }) => ({
  marginTop: theme.spacing(2),
}));

// Component Definition
const DirectorsCard = ({ directors }: Props): JSX.Element => {
  return (
    <StyledSection>
      <DetailCard
        avatarAriaLabel="Directors Table"
        avatarIcon={<GroupIcon />}
        content={<OrganizationDirectorsTable directors={directors} />}
        title="Directors"
      />
    </StyledSection>
  );
};

export default DirectorsCard;
